import PropTypes from 'prop-types';
import React from 'react';
import styles from './BrandImage.css';

class BrandImage extends React.Component {
  render() {
    const {
      businessName,
      businessLogo,
      outletAddress,
      outletPhone,
    } = this.props;
    return (
      <div className={styles['receipt-brand-img']}>
        {!businessLogo && (
          <img
            className={styles['business-logo']}
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDAiIGhlaWdodD0iMTQwIj48cmVjdCB3aWR0aD0iMTQwIiBoZWlnaHQ9IjE0MCIgZmlsbD0iI2VlZSIvPjx0ZXh0IHRleHQtYW5jaG9yPSJtaWRkbGUiIHg9IjcwIiB5PSI3MCIgc3R5bGU9ImZpbGw6I2FhYTtmb250LXdlaWdodDpib2xkO2ZvbnQtc2l6ZToxMnB4O2ZvbnQtZmFtaWx5OkFyaWFsLEhlbHZldGljYSxzYW5zLXNlcmlmO2RvbWluYW50LWJhc2VsaW5lOmNlbnRyYWwiPjE0MHgxNDA8L3RleHQ+PC9zdmc+"
          />
        )}
        {businessLogo && (
          <img src={businessLogo} className={styles['business-logo']} />
        )}
        <div className={styles['receipt-business-info-box']}>
          <div className={styles['receipt-business-name']}>{businessName}</div>
          <div
            className={`receipt-business-address ${
              styles['receipt-business-address']
            }`}
          >
            {outletAddress}
          </div>
          <div className={styles['receipt-business-phone']}>
            <span className="glyphicon glyphicon-earphone" /> +62{' '}
            {outletPhone[0] === '0' ? outletPhone.substr(1) : outletPhone}
          </div>
        </div>
      </div>
    );
  }
}

BrandImage.propTypes = {
  businessName: PropTypes.string,
  outletAddress: PropTypes.string,
  outletPhone: PropTypes.string,
  businessLogo: PropTypes.string,
};

export default BrandImage;
